import React, { Component } from 'react'

export default class titleContainer extends Component {
  render() {
    const { slogan, tie } = this.props;
    return (
      <div className={global.constants.channel==="mengduo"? "banner_mengduo":"banner"}>
        <div className="banner--content">
          <img src={slogan} alt="slogan" />
          <img src={tie} alt="" />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/titleContainer.js